/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AttributeTypeDTO } from './AttributeTypeDTO';
import {
    AttributeTypeDTOFromJSON,
    AttributeTypeDTOFromJSONTyped,
    AttributeTypeDTOToJSON,
} from './AttributeTypeDTO';
import type { FileRefDTO } from './FileRefDTO';
import {
    FileRefDTOFromJSON,
    FileRefDTOFromJSONTyped,
    FileRefDTOToJSON,
} from './FileRefDTO';

/**
 * 
 * @export
 * @interface FileRefSeriesAttributeDTO
 */
export interface FileRefSeriesAttributeDTO {
    /**
     * 
     * @type {string}
     * @memberof FileRefSeriesAttributeDTO
     */
    attributeName: string;
    /**
     * 
     * @type {AttributeTypeDTO}
     * @memberof FileRefSeriesAttributeDTO
     */
    attributeType: AttributeTypeDTO;
    /**
     * 
     * @type {FileRefDTO}
     * @memberof FileRefSeriesAttributeDTO
     */
    last?: FileRefDTO;
    /**
     * 
     * @type {number}
     * @memberof FileRefSeriesAttributeDTO
     */
    lastStep?: number;
}



/**
 * Check if a given object implements the FileRefSeriesAttributeDTO interface.
 */
export function instanceOfFileRefSeriesAttributeDTO(value: object): value is FileRefSeriesAttributeDTO {
    if (!('attributeName' in value) || value['attributeName'] === undefined) return false;
    if (!('attributeType' in value) || value['attributeType'] === undefined) return false;
    return true;
}

export function FileRefSeriesAttributeDTOFromJSON(json: any): FileRefSeriesAttributeDTO {
    return FileRefSeriesAttributeDTOFromJSONTyped(json, false);
}

export function FileRefSeriesAttributeDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileRefSeriesAttributeDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'attributeName': json['attributeName'],
        'attributeType': AttributeTypeDTOFromJSON(json['attributeType']),
        'last': json['last'] == null ? undefined : FileRefDTOFromJSON(json['last']),
        'lastStep': json['lastStep'] == null ? undefined : json['lastStep'],
    };
}

export function FileRefSeriesAttributeDTOToJSON(value?: FileRefSeriesAttributeDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'attributeName': value['attributeName'],
        'attributeType': AttributeTypeDTOToJSON(value['attributeType']),
        'last': FileRefDTOToJSON(value['last']),
        'lastStep': value['lastStep'],
    };
}

